export default __webpack_public_path__ + "static/media/previous-page-arrow.496bf57a.svg";